import axios from "axios";
import { clearAllCookies, clearItem, getItem } from "../view/Utils/CommonFunction/CommonFunction";
import { CMP_DELETE_USER } from "../common/config";

const prepareHeaders = () => {
    const accessToken = getItem('accessToken');
    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    };
};

export const UserDeleteService = async (payload) => {
    try {
        const response = await axios({
            method: 'delete',
            url: CMP_DELETE_USER,
            headers: prepareHeaders().headers,
            data: payload,
        });
        return response;
    } catch (error) {
        if (error?.response?.status == 401) {
            window.location.reload()
            clearAllCookies();
            clearItem();
        }
        return error;
    }
};
